import React, { createContext, useState, useEffect, useContext } from "react";
import _ from "lodash";
import moment from "moment";
import { OrgContext } from "./OrgContext";
import I18n from "../common/I18n";
import { getFromToDate } from "../components/orders/helpers";
import AppConfig from "../config/AppConfig";
import { WarehouseContext } from "./WarehouseContext";

const SearchConfigContext = createContext({});

// const dafaultScreenData = {
//   BILLING: {
//     filteredData: {
//       accountCodes: [],
//       viewType: "byOrder",
//       fromDate: moment().subtract(AppConfig.invoices_filter_duration, "day"),
//       toDate: moment(),
//       driver_id: "",
//       invoiceAmountFilter: "BOTH",
//       search_order_token: "",
//       warehouse_id: "",
//     },
//     filter: I18n.t("invoices.ready_for_billing"),
//     paginationData: {},
//     innerTablePaginationData: {},
//     tableOptions: {},
//     innerTableOptions: {},
//     activeAccounts: [],
//   },
//   INVOICE: {
//     filteredData: {
//       fromDate: moment().subtract(AppConfig.invoices_filter_duration, "day"),
//       toDate: moment(),
//       accountCode: "",
//       wh_location_id: "",
//       viewType: "byOrder",
//       currentStatus: "PENDING",
//       sortBy: "none",
//       sortByType: "descend",
//       approvalDate: "billing_approval_date",
//     },
//     paginationData: {},
//     innerTablePaginationData: {},
//     tableOptions: {},
//     innerTableOptions: {},
//     searchBy: "Invoice",
//     searchedItem: "",
//     isSearching: false,
//     activeAccounts: [],
//   },
// };

const SearchConfigContextProvider = ({ children }) => {
  const { getSelectesWHs } =  useContext(WarehouseContext);
  const dafaultScreenData = {
    BILLING: {
      filteredData: {
        accountCodes: [],
        viewType: "byOrder",
        fromDate: moment().subtract(AppConfig.invoices_filter_duration, "day"),
        toDate: moment(),
        driver_id: "",
        invoiceAmountFilter: "BOTH",
        search_order_token: "",
        warehouse_id: getSelectesWHs(),
        approvalDate:moment(),
        accountCodes:[],
        los:"",
        search_key_type: "",
        search_key_value: "",
        search_type: "EQUALS",
        paper_work: "ALL"
      },
      filter: I18n.t("invoices.ready_for_billing"),
      paginationData: {},
      innerTablePaginationData: {},
      tableOptions: {},
      innerTableOptions: {},
      activeAccounts: [],
      sortEntireTable: false,
    },
    INVOICE: {
      filteredData: {
        fromDate: moment().subtract(AppConfig.invoices_filter_duration, "day"),
        toDate: moment(),
        accountCode: "",
        // wh_location_id: "",
        warehouse_ids: getSelectesWHs(),
        viewType: "byOrder",
        currentStatus: "PENDING",
        sortBy: "none",
        sortByType: "descend",
        approvalDate: "billing_approval_date",
        frequencyType: "",
        search_key_type: "",
        search_key_value: "",
        search_type: "EQUALS",
        isEdiStatusOpted: false,
        edi_status: ""
      },
      paginationData: {},
      innerTablePaginationData: {},
      tableOptions: {},
      innerTableOptions: {},
      searchBy: "Invoice",
      searchedItem: "",
      isSearching: false,
      activeAccounts: [],
    },
    DUE_PAYMENTS: {
      filteredData: {
        accountId: "",
        categoryType: "SUMMARY",
        listType: "unpaid",
        from_date: moment().subtract(3, "months").format("YYYY-MM-DD"),
        to_date: moment().format("YYYY-MM-DD"),
      },
      searchType: "EQUALS",
      searchKeyType: "",
      searchToken: "",
      closedPaymentsFilter: {
        paginationData: {},
        tableOptions: {},
      },
      openDetailFilter: {
        paginationData: {},
        tableOptions: {},
        selectedInfo: {
          keys: [],
          rows: [],
        },
        selectedInvoices: [],
      },
      openSummaryFilter: {
        paginationData: {},
        tableOptions: {},
        selectedInfo: {
          keys: [],
          rows: [],
        },
        selectedInvoices: [],
      },
    },
    ACCOUNT_RECEIVABLES: {
      sortEntireTable: false,
      filteredData: {
        selectedAccounts: [],
      },
    },
    ACCOUNTS: {
      filteredData: {
        token: "",
        sortBy: "name",
        sortByType: "ascend",
        status: "active",
        warehouse_ids: []
      },
      paginationData: {},
      tableOptions: {},
    },
    MANAGE_MASTER_CHECKS: {
      sortEntireTable: false,
      filteredData: {
        from_date: moment().subtract(29, "day"),
        to_date: moment(),
        status: "BOTH",
        sortBy: "none",
        sortByType: "descend",
      },
      searchText:""
    },
    MANAGE_ACCOUNT_CHECKS: {
      sortEntireTable: false,
      filteredData: {
        from_date: moment().subtract(29, "day"),
        to_date: moment(),
        status: "BOTH",
        sortBy: "none",
        sortByType: "descend",
      },
      searchText:""
    },
    CREDIT_MEMO: {
      sortEntireTable: false,
    },
    SUMMARY_VIEW: {
      sortEntireTable: false,
    },
    DETAIL_VIEW: {
      sortEntireTable: false,
    },
    BATCH_HOME_SCREEN: {
      sortEntireTable: false,
      filteredData: {
        formattedFrom_date: moment().subtract(6, "day"),
        formattedTo_date: moment(),
      },
      searchText: "",
      searchKeyType: "",
      searchType: "EQUALS",
      paginationData: {},
    },
    DRIVERS_PER_DAY: {
      filteredData: {
        fromDate: moment().subtract(6, "days"),
        toDate: moment(),
        drivers: [],
        warehouse_ids: [],
        status: "BOTH"
      }
    },
    ORDER_DETAILS_SETTLEMENTS: {
      filteredData: {
        fromDate: moment().subtract(6, "days"),
        toDate: moment(),
        drivers: [],
        warehouse_ids: [],
        status: "BOTH"
      }
    },
    FAILED_SETTLEMENTS: {
      filteredData: {
        fromDate: moment().subtract(6, "days"),
        toDate: moment(),
        drivers: [],
        warehouse_ids: [],
        status: "BOTH"
      }
    },

  };
  const [screenData, setScreenData] = useState({
    ...dafaultScreenData
  });

  // const updateFilteredData = (screenFrom, updatedField, value) => {
  //   setScreenData((prevState) => {
  //     if (prevState[screenFrom]) {
  //       return {
  //         ...prevState,
  //         [screenFrom]: {
  //           ...prevState[screenFrom],
  //           [updatedField]: value,
  //         },
  //       };
  //     }
  //     return prevState;
  //   });
  // };

  const updateFilteredData = (screenFrom, dataToUpdate) => {
    setScreenData((prevState) => {
      if (prevState[screenFrom]) {
        return {
          ...prevState,
          [screenFrom]: {
            ...prevState[screenFrom],
            ...dataToUpdate,
          },
        };
      }
      return prevState;
    });
  };

  const contextValues = { screenData, updateFilteredData };

  return (
    <SearchConfigContext.Provider value={contextValues}>
      {children}
    </SearchConfigContext.Provider>
  );
};

export { SearchConfigContext, SearchConfigContextProvider };
